import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence non-essential console output in PRODUCTION builds only.
// Keeps console.warn / console.error for real problems; dev & preview keep all logs.
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
